<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          color="primary"
          :name="`vehicle-list-edit-${params?.rowIndex}`"
          class="ml-1 mr-2"
          v-on="on"
          v-bind="attrs"
          @click="editItem"
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.change
          "
          >mdi-pencil</v-icon
        >
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          :name="`vehicle-list-view-${params?.rowIndex}`"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewItem"
          >mdi-eye</v-icon
        >
      </template>
      <span>View</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          :name="`vehicle-incident-view-${params?.rowIndex}`"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="incidentLogs"
          >mdi-clipboard-text</v-icon
        >
      </template>
      <span>Incident Log</span>
    </v-tooltip>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="params?.context?.parentComponent"
          class="ml-2 mr-1"
          :color="is_vehicle_active === 'No' ? 'grey' : 'primary'"
          :style="{ opacity: is_vehicle_active === 'No' ? 0.5 : 1 }"
          v-on="on"
          v-bind="attrs"
          @click="changeStatus"
        >
          mdi-toggle-switch
        </v-icon>
      </template>
      <span>Active/ De-active Vehicle</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  computed: {
    is_vehicle_active() {
      const status = this.params?.data?.status;
      return status === "Deactivated" ? "No" : "Yes";
    },
  },
  methods: {
    editItem() {
      this.params.context.parentComponent.editVehicle(this.params.data.id);
    },
    viewItem() {
      this.params.context.parentComponent.viewVehicle(this.params.data.id);
    },
    incidentLogs() {
      this.params.context.parentComponent.createIncidentLogs(this.params.data);
    },
    changeStatus() {
      if (this.params) {
        this.params.context.parentComponent.confirmation(
          this.params.data.id,
          this.is_vehicle_active == "Yes" ? false : true
        );
      }
    },
  },
};
</script>
